import {useGetCompanyInfoQuery, useGetUserRolesQuery} from "../generated/graphql";
import Roles from "../../shared/models/roles";
import {routePermissions} from "../containers/common/AuthenticateSetup";
import {URL_COURSES_DISCOUNT_CODES} from "../models/url";

/** Rabattcodes (Beta) im Büro: Tenant-Flag und Rolle wie beim Reiter „Rabattcodes“ (ab Admin). */
export const useDiscountCodesAllowed = (): boolean => {
    const {data: companyInfoData} = useGetCompanyInfoQuery({fetchPolicy: "cache-first"});
    const {data: rolesData} = useGetUserRolesQuery();
    const rolesOfCurrent = rolesData?.getUserRoles?.rolesOfCurrent ?? [];

    return Boolean(companyInfoData?.companyInfo?.subscription?.featureDiscountCodes) && rolesOfCurrent.some((role: Roles) => routePermissions[URL_COURSES_DISCOUNT_CODES].includes(role));
};
